module.exports = __webpack_public_path__ + "static/media/Accident_core.3023bffe.png";